/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import { useEffect, useRef } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Dropzone components
import Dropzone from "dropzone";

// Dropzone styles
import "dropzone/dist/dropzone.css";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";

// Custom styles for the MDDropzone
import MDDropzoneRoot from "components/MDDropzone/MDDropzoneRoot";

// Material Dashboard 2 PRO React context
import { useMaterialUIController } from "context";
import { PHOTOGRAPHS } from "../../../../../helpers/constants/url";
import { useGetPhotosByEventQuery, useUploadEventPhotoMutation } from "../../../../../store/api/events";
import { useDispatch } from "react-redux";
import { notificationActions } from "../../../../../store/notification/notification-slice";

function PhotoDropzone({ options, event_id }) {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [uploadPhoto] = useUploadEventPhotoMutation()
  const dispatch = useDispatch();
  const res = useGetPhotosByEventQuery(event_id);
  const dropzoneRef = useRef();
  Dropzone.autoDiscover = false;

  useEffect(() => {

    function createDropzone() {
      const myDropzone = new Dropzone(dropzoneRef.current, { ...options });
      myDropzone.on("sending", function(file, xhr, formData) {
      // Will sendthe filesize along with the file as POST data.
        formData.append("event", event_id);
      });
      myDropzone.on("queuecomplete", function(file, xhr, formData) {
        // Will sendthe filesize along with the file as POST data.
        res.refetch();
      });
      myDropzone.on("error", function(file, errorMessage) {
        // Will sendthe filesize along with the file as POST data.
        dispatch(
          notificationActions.showMessage({ message: errorMessage, variant: "error" })
        );
      });
      myDropzone.on("removedfile", (file)=>{
      });
      // myDropzone.on("addedfile", async (file, xhr, formData) => {
      //   // Will sendthe filesize along with the file as POST data.
      //   console.log(file)
      //   formData = new FormData();
      //   formData.append("file", file);
      //   formData.append("event", event_id);
      //   const payload = await uploadPhoto(formData);
      //   console.log(payload);
      //   file.status = "success"
      //   console.log(formData)
      //   console.log("addedfile")
      //   this.emit("complete", file);
      // });
      return myDropzone

    }

    function removeDropzone() {
      if (Dropzone.instances.length > 0) Dropzone.instances.forEach((dz) => dz.destroy());
    }

    createDropzone();

    return () => removeDropzone();
  }, [options]);
  return (
    <MDDropzoneRoot
      component="form"
      action={PHOTOGRAPHS}
      ref={dropzoneRef}
      className="form-control dropzone"
      ownerState={{ darkMode }}
    >
      <MDBox className="fallback" bgColor="transparent">
        <MDBox component="input" name="file" type="file" multiple />
      </MDBox>
    </MDDropzoneRoot>
  );
}

// Typechecking props for the MDDropzone
PhotoDropzone.propTypes = {
  options: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default PhotoDropzone;
